import { Component } from "react";
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { connect } from "react-redux";
import ModalContainer from "../../../../../common/modal/modal-container/modal-container.component";
import OutputMultipleColumn from "../form/output-multiple-column.component";
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";
import { OutputConfigurationDetailsActions } from "../../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";

class OutputMultipleColumnModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNotif: false,
            haveError: false,
            haveValueError: false,
            haveColumnError: false,
            showModal: false,
            modalMessage: 'test message',
            originalSelectedMultipleSourceData: []
        };
    }

    handleCloseFormModal = () => {
        if (this.props.handleCloseFormModal) {
            this.props.handleCloseFormModal();
        }
    };

    handleCloseNotif = () => {
        if (this.state.haveError) {
            this.setState({ showNotif: false });
        }
        else {
            this.setState({ showNotif: false });
            this.handleCloseFormModal();
        }
    };

    handlePrimaryBtn = () => {
        const { outputColumnsDatatable } = this.props.outputConfigurationDetails;
        const { fieldFormMultiple } = this.props;

        this.setState({
            haveValueError: false,
            haveColumnError: false,
        });
        const value = fieldFormMultiple?.Values;

        if (!value || typeof value !== 'string') {
            this.setState({
                showNotif: true,
                haveError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_invalid_empty_validation
            });
            return;
        }

        // Step 1: Extract all valid bracketed tokens
        const bracketedRegex = /\[([^\]]+)\]/g;
        const allowedKeywordsLower = [
            "[column source 1]",
            "[column source 2]",
            "[column source 3]"
        ];

        const bracketedMatches = value.match(bracketedRegex) || [];

        // Step 1.1: Reject empty brackets like [] or [   ]
        const invalidEmptyBrackets = value.match(/\[\s*\]/g);
        if (invalidEmptyBrackets) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_empty_bracket_validation
            });
            return;
        }

        // Step 1.2: Check for unmatched or unclosed brackets
        const unmatchedOpening = value.match(/\[[^\]]*$/); // opening [ without matching ]
        const unmatchedClosing = value.match(/^[^\[]*\]/);  // closing ] without opening [

        if ((value.match(/\[/g)?.length || 0) !== bracketedMatches.length ||
            (value.match(/\]/g)?.length || 0) !== bracketedMatches.length ||
            unmatchedOpening || unmatchedClosing) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_invalid_bracket_validation
            });
            return;
        }

        const seen = new Set();

        for (const match of bracketedMatches) {
            const lowerMatch = match.toLowerCase();
            if (!allowedKeywordsLower.includes(lowerMatch)) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    haveValueError: true,
                    modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_invalid_column_source_keyword_validation + `${match}`
                });
                return;
            }

            if (seen.has(lowerMatch)) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    haveValueError: true,
                    modalMessage: `${match}` + MODAL_CUSTOM_MESSAGE.multiple_source_multiple_column_source_keyword_validation
                });
                return;
            }

            seen.add(lowerMatch);
        }

        // Step 2: Check number of valid tokens
        if (seen.size < 2) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_single_source_validation
            });
            return;
        }

        // Step 3: Check for unbracketed COLUMN SOURCE X (case-insensitive)
        const unbracketedPattern = /(?<!\[)(column source 1|column source 2|column source 3)(?!\])/gi;
        if (value.match(unbracketedPattern)) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_open_closed_bracket_validation
            });
            return;
        }

        // Step 4: Temporarily remove valid bracketed keywords, then check for spaces outside
        const valueWithoutKeywords = value.replace(bracketedRegex, '');
        if (/\s/.test(valueWithoutKeywords)) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_spaces_validation
            });
            return;
        }

        // Step 5: Only allow specific characters
        const allowedPattern = /^[a-zA-Z0-9*\/+\-_.\[\]\s]*$/;
        if (!allowedPattern.test(value)) {
            this.setState({
                showNotif: true,
                haveError: true,
                haveValueError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.multiple_source_invalid_character_validation
            });
            return;
        }

        // Step 6: Check for duplicate ColumnName
        if (outputColumnsDatatable?.dataTable?.[0]?.dataItem?.length > 0) {
            const alreadyExist = this.props.rowColumnName?.trim().toLowerCase() === fieldFormMultiple.ColumnName?.trim().toLowerCase() ? false : outputColumnsDatatable.dataTable[0].dataItem.some(
                (item) =>
                    item.ColumnName?.trim().toLowerCase() === fieldFormMultiple.ColumnName?.trim().toLowerCase()
            );

            if (alreadyExist) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    haveColumnError: true,
                    modalMessage: MODAL_CUSTOM_MESSAGE.output_record_already_exist
                });
                return;
            }
        }

        if (!this.props.isUpdate && this.props.isGreaterThanOrEqual30) {
            this.setState({
                showNotif: true,
                haveError: true,
                modalMessage: MODAL_CUSTOM_MESSAGE.output_record_30_exeed_validation
            });
            return;
        }

        // Passed all validation
        this.props.addUpdateOutputColumn();
        this.setState({
            showNotif: true,
            haveError: false,
            haveColumnError: false,
            haveValueError: false,
            modalMessage: this.props.isUpdate ? MODAL_CUSTOM_MESSAGE.multiple_source_to_output_column_update : MODAL_CUSTOM_MESSAGE.multiple_source_to_output_column_add
        });
    };

    isFormChanged = () => {
        const { fieldFormMultiple } = this.props;
        const { originalSelectedMultipleSourceData } = this.state;

        if (!originalSelectedMultipleSourceData?.[0]?.[0]) return true;

        const original = originalSelectedMultipleSourceData[0][0];

        return (
            fieldFormMultiple.ColumnName?.trim() !== original.ColumnName?.trim() ||
            fieldFormMultiple.Values?.trim() !== original.Values?.trim() ||
            parseInt(fieldFormMultiple.ColumnSourceID1) !== parseInt(original.ColumnSourceID1) ||
            parseInt(fieldFormMultiple.ColumnSourceID2) !== parseInt(original.ColumnSourceID2) ||
            parseInt(fieldFormMultiple.ColumnSourceID3) !== parseInt(original.ColumnSourceID3) ||
            parseInt(fieldFormMultiple.ColumnFormatID1) !== parseInt(original.ColumnFormatID1) ||
            parseInt(fieldFormMultiple.ColumnFormatID2) !== parseInt(original.ColumnFormatID2) ||
            parseInt(fieldFormMultiple.ColumnFormatID3) !== parseInt(original.ColumnFormatID3)
        );
    };

    render() {
        const { primaryBtnTooltip, secondaryBtnTooltip, showSecondarybtn, primaryBtnLabel,
            columnSourceOption, columnFormatOption, optionLabelKey, fieldFormMultiple, fieldPropMultiple,
            columnFormat1Option, columnFormat2Option, columnFormat3Option
        } = this.props;
        const columnSourceIds = [
            fieldFormMultiple.ColumnSourceID1,
            fieldFormMultiple.ColumnSourceID2,
            fieldFormMultiple.ColumnSourceID3
        ];

        const nonZeroCount = columnSourceIds.filter(id => parseInt(id) && parseInt(id) !== 0 && parseInt(id) !== 30).length;

        const disableButton =
            fieldFormMultiple.ColumnName !== '' &&
            fieldFormMultiple.Values !== '' &&
            nonZeroCount >= 2 &&
            this.isFormChanged();
        return (
            <div className="output-multiple-column-modal">
                <ModalContainer
                    title="column_source_multiple"
                    show={this.props.showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={false}
                    saveDetails={this.handlePrimaryBtn}
                    secondaryBtnFc={this.handleSecondary}
                    customClass="cost-allocation-details__modal article_detail__container"
                    disabled={!disableButton}
                    isReadAndWrite={true}
                    buttonName={primaryBtnLabel}
                    showSecondarybtn={showSecondarybtn}
                    primaryBtnTooltip={primaryBtnTooltip}
                    secondaryBtnTooltip={secondaryBtnTooltip}
                >
                    <OutputMultipleColumn
                        ref={(ref) => this.childRef = ref}
                        columnSourceOption={columnSourceOption}
                        columnFormatOption={columnFormatOption}
                        columnFormat1Option={columnFormat1Option}
                        columnFormat2Option={columnFormat2Option}
                        columnFormat3Option={columnFormat3Option}
                        optionLabelKey={optionLabelKey}
                        fieldForm={fieldFormMultiple}
                        fieldProp={fieldPropMultiple}
                        setOriginalMultipleSourceData={(data) => this.setState({ originalSelectedMultipleSourceData: data })}
                        rowColumnName={this.props.rowColumnName}
                        haveColumnError={this.state.haveColumnError}
                        haveValueError={this.state.haveValueError}
                    />

                </ModalContainer>
                <NotificationModal
                    show={this.state.showNotif}
                    title={this.state.haveError ? 'Error' : 'Success'}
                    message={this.state.modalMessage}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
            </div>
        );
    }
}
export default connect(
    state => {
        const { translation, outputConfigurationDetails } = state;
        return {
            ...translation,
            outputConfigurationDetails
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, OutputConfigurationDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value));
        },
    })
)(OutputMultipleColumnModal);
